import { useTranslation } from "react-i18next";
import TooltipContent from "../components/TooltipContent";

type TooltipKey =
  | "totalItems"
  | "nonFieldItems"
  | "issuedToField"
  | "neverScanned"
  | "scanAge"
  | "scanAgeDistribution"
  | "statusBreakdown"
  | "itemsBySite"
  | "siteSummary"
  | "overdue0to7"
  | "overdue8to30"
  | "overdue31to90"
  | "overdue90plus"
  | "timeOnSite"
  | "requiredStockLevel"
  | "immobilizedStock"
  | "clients"
  | "keyFindings";

const useReportTooltip = (key: TooltipKey, extraDetails?: string[]) => {
  const { t } = useTranslation();

  const description = t(`reports.inventoryScan.tooltips.${key}.description`);
  const details = t(`reports.inventoryScan.tooltips.${key}.details`, {
    returnObjects: true,
  }) as string[];

  const allDetails = extraDetails ? [...details, ...extraDetails] : details;

  return <TooltipContent description={description} details={allDetails} />;
};

export default useReportTooltip;
